module.exports = __webpack_public_path__ + "img/dump_truck_h.80288237.png";